module.exports = __webpack_public_path__ + "img/roleDel.f1ec2c4b.svg";